import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import styles from './VideoBlock.module.scss';

import classNames from 'classnames';

const VideoModule = dynamic(() => import('../VideoModule'), { ssr: false });

const VideoBlock = ({ vimeoUrl, overlayImage, descriptiveText, small }) => {
    const isMediaflow = vimeoUrl.includes('mediaflow');

    const classes = classNames(styles['VideoBlock'], {
        [styles['VideoBlock--Small']]: small,
    });
    return (
        <div className={classes}>
            {isMediaflow && (
                <VideoModule
                    videoUrl={vimeoUrl}
                    overlayImage={overlayImage.image}
                    descriptiveText={descriptiveText}
                />
            )}
        </div>
    );
};

VideoBlock.propTypes = {
    overlayImage: PropTypes.object,
    vimeoUrl: PropTypes.string,
    descriptiveText: PropTypes.string,
    small: PropTypes.bool,
};

VideoBlock.defaultProps = {
    overlayImage: {},
    vimeoUrl: '',
    descriptiveText: '',
    small: false,
};

export default VideoBlock;
